import { Link } from 'react-router-dom'
import { Icon20 } from 'builder/components/Icon'
import { InfoBox } from '../../elements/InfoBox/InfoBox'
import { useThemeConfig } from '../../hooks/useThemeConfig'
import { ActionButton, WidgetBox, WidgetImage } from '../../widget.styles'
import { WidgetProps } from '../../widget.types'
import { WidgetTheme } from '../../WidgetTheme'
import { useQuestionsPracticedConfig } from './useQuestionsPracticedConfig'

export const QuestionsPracticed = ({ service }: WidgetProps) => {
  const { status, text, actionLink, image } = useQuestionsPracticedConfig({ progress: 10 })
  const themeState = useThemeConfig({ service })
  const theme = themeState.initial

  return (
    <WidgetTheme theme={theme} tipOrder={1}>
      <WidgetBox>
        <InfoBox text={text} isCompleted={status === 'completed'}>
          <ActionButton as={Link} to={actionLink}>
            {text.actionText}
            <Icon20.ChevronRightRegular />
          </ActionButton>
        </InfoBox>
      </WidgetBox>
      <WidgetBox>
        <WidgetImage src={image} alt={text.imageAlt} />
      </WidgetBox>
    </WidgetTheme>
  )
}
